import { parseCropString as e, parseFocusString as t } from "../../components/CropDialog/softcrop-lib.es.js";
import { CropDialog as n } from "../../components/CropDialog/CropDialog.es.js";
import { VisualCrop as r } from "../../components/CropDialog/VisualCrop.es.js";
import { VisualFocus as i } from "../../components/CropDialog/VisualFocus.es.js";
import { useEffect as a, useRef as o, useState as s } from "react";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
import { Element as d, Transforms as f } from "slate";
//#region lib/Image/components/FigureImage.tsx
var p = ({ editor: p, children: m, rootNode: h, options: g }) => {
	let { properties: _ = {} } = d.isElement(h) ? h : {}, v = g?.enableCrop ?? !0, y = g?.getImageSrc, b = _?.src ?? void 0, x = _?.uploadId ?? void 0, S = o(_);
	S.current = _;
	let [C, w] = s();
	a(() => {
		if (!y) {
			w(b);
			return;
		}
		let e = y(S.current);
		typeof e == "string" ? w(e) : e.then(w).catch(() => w(""));
	}, [
		b,
		x,
		y
	]);
	let T = _?.focus || void 0, E = _?.crop || void 0, D = o(null), O = e(E), k = t(T);
	return /* @__PURE__ */ u("div", {
		contentEditable: !1,
		draggable: !0,
		children: [/* @__PURE__ */ u("div", {
			ref: D,
			className: "relative rounded rounded-xs overflow-hidden",
			children: [/* @__PURE__ */ l("img", {
				width: "100%",
				src: C
			}), v && C && /* @__PURE__ */ u(c, { children: [
				O && /* @__PURE__ */ l(r, { crop: O }),
				k && /* @__PURE__ */ l(i, { focus: k }),
				/* @__PURE__ */ l(n, {
					src: C,
					area: O,
					point: k,
					onChange: ({ crop: e, focus: t }) => {
						let n = p.children.findIndex((e) => e.id === h?.id);
						if (n < 0) return;
						let r = e ? `${e.x} ${e.y} ${e.w} ${e.h}` : void 0, i = t ? `${t.x} ${t.y}` : void 0;
						f.setNodes(p, { properties: {
							...h.properties,
							crop: r,
							focus: i
						} }, { at: [n] });
					}
				})
			] })]
		}), m]
	});
};
//#endregion
export { p as FigureImage };
